import { useAuth } from '~/store/auth'
import { track, setUserId } from '~/utils/Amplitude'
import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'

export const generateAti = () => {
  return '10000000-1000-4000-8000-100000000000'.replace(
    /[018]/g,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (c: any) => {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    }
  )
}

export default defineNuxtRouteMiddleware(async () => {
  if (process.server) {
    return
  }

  const sessionReplayTracking = sessionReplayPlugin()
  amplitude.add(sessionReplayTracking)

  amplitude.init(useRuntimeConfig().public.amplitudeApiKey, { defaultTracking: true })

  const ati = useCookie('amplitude_track_id', {
    expires: new Date(Date.now() + 10 * 365 * 24 * 3600 * 1000),
  })

  const userStore = useAuth()

  let visitFirstTime = false
  if (!ati.value) {
    if (userStore.user?.ati !== null && userStore.user?.ati !== undefined) {
      ati.value = userStore.user.ati
    } else {
      visitFirstTime = true
      ati.value = generateAti()
      if (userStore.user) {
        userStore.user.ati = ati.value
      }
    }
  }

  setUserId(<string>ati.value, userStore.user?.email)

  if (visitFirstTime) {
    track('Visit first time', {
      user_id: ati.value,
    })
  }

  const isActive = useCookie('is_active')
  if (!isActive.value) {
    track('Session start')
  }
})
